//时间戳转换
export function changeTime(stamp) {
    let time = new Date(stamp * 1000);
    let month = time.getMonth() + 1 > 12 ? 1 : time.getMonth() + 1;
    return time.getFullYear() + '-' + month + '-' + time.getDay() + ' ' + time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds()
}

/**将utc时间转换 */
import moment from 'moment-timezone' //引入moment

/**
* 格式化秒数为 UTC+时区时间格式
* */
//time为毫秒级时间戳，timezone为国际时区
export function timeFilter(time) {
    if (!time) return '--'
    time = Number(time) * 1000;    // 保证为number类型
    // let timezoneName = moment.tz.guess(true);
    // let timezone = timezoneName || 'Etc/UTC'
    // let timeFoot = moment(time).tz(timezone).format('Z')
    let timeHead = moment(time).format('YYYY/MM/DD HH:mm:ss');
    return time ? timeHead : '--'
}


// 检查客户端
export function judgeClient() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
    console.log('是否是Android：' + isAndroid); //true,false
    console.log('是否是iOS：' + isIOS);
    if (isAndroid) {
        return 'Android';
    } else if (isIOS) {
        return 'IOS';
    } else {
        return 'PC';
    }
}

//计算相差天数
export function countDays(time) {
    time = time*1000
    let date1 = new Date(time);
    let date2 = new Date();
    date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    const diff = date1.getTime() - date2.getTime(); //目标时间减去当前时间
    return Math.abs(diff / (24 * 60 * 60 * 1000));
}

//base64编码
let Base64 = require('js-base64').Base64;
export function enCodeBase64(str) {
    return Base64.encode(str)
}

//base64解码
export function deCodeBase64(code) {
    return Base64.decode(code)
}